const MAX_DIAGNOSTIC_TEXT_LENGTH = 500;

const redactSensitiveValues = (value) =>
  value
    .replace(/\b(bearer\s+)[^\s,;]+/gi, '$1[REDACTED]')
    .replace(/\beyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\b/g, '[REDACTED]')
    .replace(
      /\b(api[_-]?key|token|password|senha|secret|segredo|credential|credencial)\s*[:=]\s*[^\s,;]+/gi,
      '$1=[REDACTED]'
    );

export const sanitizeDiagnosticText = (value, maxLength = MAX_DIAGNOSTIC_TEXT_LENGTH) => {
  let text = '';

  try {
    text = String(value || '');
  } catch {
    return '';
  }

  const sanitizedText = redactSensitiveValues(text).replace(/[\r\n\t]+/g, ' ').trim();

  return sanitizedText.slice(0, maxLength);
};

export { MAX_DIAGNOSTIC_TEXT_LENGTH };
